﻿<template>
    <div v-if="errorsArr.length > 0">
        <div class="validation-summary-errors">
            <p v-for="err in errorsArr" :key="err">{{ err }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                type: [String, Array],
                required: true,
                default: function () {
                    return [];
                }
            },
            success: null
        },

        data: () => ({
            errorsArr: []
        }),

        watch: {
            errors() {
                this.errorsArr = this.errors instanceof Array ? this.errors : [this.errors];
            }
        }
    };
</script>